<template>
  <div>
    <v-autocomplete autocomplete="off"
      density="compact"
      :hint="hint"
      :label="label"
      :items="suggestions"
      :model-value="value"
      :search="searchValue"
      @update:model-value="onSelect"
      @update:search="onInput"
      return-object
      item-title="value"
      no-filter
      persistent-hint
      :variant="variant"
      :readonly="isServiceError"
      :disabled="isServiceError"
      :class="{ 'dadata-service-error': isServiceError }"
      @focus="onFocus"
      @blur="onBlur"
      @keydown="onKeydown"
    ></v-autocomplete>
    <div v-if="isServiceError" class="text-error text-caption mt-1">
      Сервис подсказок недоступен. Возможные причины: отсутствует интернет, превышен лимит запросов или некорректный токен.
    </div>
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue", "service-error"],
  props: {
    label: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    token: {
        required: true,
        type: [String, Boolean],
    },
    variant: {
      type: String,
      default: "outlined",
    },
    debounceMs: {
      type: Number,
      default: 300,
    },
    /**
     * {
     *     value:"",
     *     data:{}
     * }
     */
    modelValue: {
      required: true,
      type: Object
    },
  },
  data() {
    return {
      suggestions: [],
      isServiceError: false,
      isLoading: false,
      debounceTimer: null,
      isFocused: false,
      suppressSearchUpdate: false,
      allowEmptySearch: false,
      pendingSearchValue: "",
      searchValue: this.modelValue && this.modelValue.value
        ? this.modelValue.value
        : "",
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  created() {},
  watch: {
    "modelValue.value"(value) {
      const text = value || "";

      if (text !== this.searchValue) {
        this.searchValue = text;
      }
    },
  },
  beforeUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  methods: {
    onFocus() {
      this.isFocused = true;
    },
    onKeydown(event) {
      if (event.key !== "Backspace" && event.key !== "Delete") {
        return;
      }

      this.allowEmptySearch = true;
      setTimeout(() => {
        this.allowEmptySearch = false;
      }, 250);
    },
    onInput(val) {
      if (val === null || val === undefined) {
        return;
      }

      const text = String(val || "");

      if (this.suppressSearchUpdate) {
        this.searchValue = this.pendingSearchValue || this.searchValue;
        return;
      }

      if (text === "" && this.hasStoredValue() && !this.allowEmptySearch) {
        this.restoreSearchValue();
        return;
      }

      this.allowEmptySearch = false;
      this.searchValue = text;
      this.emitTextValue(text);

      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      if (text.length >= 3) {
        this.debounceTimer = setTimeout(() => {
          this.performSearch(text);
        }, this.debounceMs);
      } else {
        this.suggestions = [];
      }
    },
    onSelect(value) {
      if (value && typeof value === "object") {
        const suggestion = this.normalizeSuggestion(value);
        this.suppressSearchUpdate = true;
        this.pendingSearchValue = suggestion.value;
        this.searchValue = suggestion.value;
        this.ensureSuggestionExists(suggestion);
        this.$emit("update:modelValue", suggestion);

        this.$nextTick(() => {
          this.suppressSearchUpdate = false;
          this.pendingSearchValue = "";
          this.restoreSearchValue();
        });
        return;
      }

      this.emitTextValue(this.searchValue);
    },
    onBlur() {
      this.isFocused = false;
      this.allowEmptySearch = false;
      this.restoreSearchValue();
    },
    hasStoredValue() {
      return Boolean(this.modelValue && this.modelValue.value);
    },
    restoreSearchValue() {
      this.searchValue = this.hasStoredValue()
        ? this.modelValue.value
        : "";
    },
    normalizeSuggestion(value) {
      return {
        ...value,
        value: value.value || "",
        data: value.data || {},
      };
    },
    ensureSuggestionExists(suggestion) {
      if (!suggestion.value) {
        return;
      }

      const exists = this.suggestions.some((item) => item.value === suggestion.value);
      if (!exists) {
        this.suggestions = [suggestion, ...this.suggestions];
      }
    },
    emitTextValue(text) {
      const currentValue = this.modelValue || {};

      this.$emit("update:modelValue", {
        ...currentValue,
        value: text,
        data: text === (currentValue.value || "")
          ? (currentValue.data || {})
          : {},
      });
    },
    performSearch(val) {
      this.isLoading = true;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + this.token,
      };

      this.axios
        .post(
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address",
          JSON.stringify({
            query: val,
          }),
          {
            headers: headers,
          }
        )
        .then((response) => {
          this.isLoading = false;
          this.isServiceError = false;
          this.suggestions = response.data.suggestions || [];
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.isServiceError = true;
          this.$emit("service-error", error);
        })
        .finally(() => {
          this.debounceTimer = null;
        });
    },
  },
};
</script>

<style scoped>
.dadata-service-error {
  opacity: 0.6;
}
</style>
